import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

import { Button } from 'components/ui';
import { useState, useEffect }            from 'react';
import ReactGA  from "react-ga4";

const REST_API_KEY = process.env.REACT_APP_KAKAO_REST_API_KEY || "";
const REDIRECT_URI = process.env.REACT_APP_KAKAO_REDIRECT_URI_WEB || "";

const Elem:React.FC<any> = ({ showModal, closeModal }) =>{
  const gaId = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;

  const handleKakaoLogin = async () => {
    if (gaId){
        ReactGA.event({
          "category" : "Button",
          "action": "Click",
          "label" : "Kakao Login Button"
        })
      }

    const scope =`phone_number`
    const KAKAO_AUTH_URL = 
    `https://kauth.kakao.com/oauth/authorize?response_type=code&client_id=${REST_API_KEY}&redirect_uri=${REDIRECT_URI}&prompt=login&scope=${scope}&auth_type=reauthenticate`
    window.location.href = KAKAO_AUTH_URL;
  };

  useEffect (() => {
    if (gaId) {
      ReactGA.send({ hitType: "pageview", page:"/login", title: "login view" })
    }
  },[]);

  return (
    <>
      <ContentsConatiner>
        <ConatinerImg>
          <PhotoImg src={"/images/landing/21/header.png"}/>
        </ConatinerImg>
        <ConatinerImg>
          <PhotoImg src={"/images/landing/21/problem21-1.png"}/>
        </ConatinerImg>
        <ConatinerImg>
          <PhotoImg src={"/images/landing/21/solution21-1.png"}/>
        </ConatinerImg>
        <ConatinerImg>
          <PhotoImg src={"/images/landing/common.png"}/>
        </ConatinerImg>
        <LoginButtonWrapper>
          <LoginButton
            onClick={handleKakaoLogin}
          >
            <LoginImg>
              <Img
                src={"/images/kakaologin.png"}
              />
            </LoginImg>
            <KakaoWrapper>
              카카오로 3초만에 시작하기</KakaoWrapper>
          </LoginButton>
        </LoginButtonWrapper>
        <ConatinerImg>
          <PhotoImg src={"/images/landing/common2.png"}/>
        </ConatinerImg>
      </ContentsConatiner>
    </>
  )
};

export default Elem;

const PhotoImg = styled.img`
  width: 100%;
  height: 100%;
`;
const ConatinerImg =styled.div`
  width: 100%;
  height: 100%;
`;

const ContentsConatiner = styled.div`
  width: 50%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: aqua;
  margin: -10px auto;
`
const SmallText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  /* font-weight: light; */
  font-weight: 300;
  font-size: 14px;
  line-height: 133%;
  color: #000000;
  margin-top: 9px;

  &.Bold {
    font-weight: medium;
    /* font-size: 15px; */
    margin-top: 3px;
  }
`
const LoginButtonWrapper = styled.div`
  height: 45px;
  display: flex;
  flex-direction: row;
`;
const LoginImg = styled.div`
  width: 14px;
  height: 14px;
  margin-right: 10px;
`;
const Img= styled.img`
  width: 100%;
  height: 100%;
`;
const LoginButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px 0;
  border-radius: 4px;
  background-color: #f9e000;
  color: #000000;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
`
const KakaoWrapper = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 15px;
  color: #3C1E1E;
`;
const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* margin-top: 16px; */
`;

const CloseContainer = styled.div`
  width: 20px;
  height: 20px;
  margin-top: 20px;
  margin-left: auto;
  margin-right: 20px;
  font-size: 16px;
`